import React from 'react';

import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { makeStyles } from '@mui/styles';

import { colors } from '../../../utils/theme';

// eslint-disable-next-line import/no-cycle -- Dependency cycle detected.
import { useRotation } from './RotationContext';

const localStyles = makeStyles(() => ({
  rerunAiErrorDialogContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 50,
  },
  okButton: {
    backgroundColor: colors.PRIMARY,
    padding: 3,
    textTransform: 'none',
    width: 100,
    color: 'white',
    '&:hover': {
      backgroundColor: 'white',
      color: colors.PRIMARY,
    },
  },
}));

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const RerunErrorDialog: React.FC<Props> = ({ open, setOpen }) => {
  const classes = localStyles();
  const { resetImageRotationState } = useRotation();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          margin: 0,
          padding: 0,
          marginRight: 400,
        }}
      >
        <DialogContent className={classes.rerunAiErrorDialogContent}>
          <DialogContentText
            id="alert-dialog-description"
            style={{ marginTop: 30 }}
          >
            We encountered an error while reanalyzing the images. If you
            continue to experience this issue, please contact support.
          </DialogContentText>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={() => {
                resetImageRotationState();
                handleClose();
              }}
              className={classes.okButton}
            >
              Ok
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default RerunErrorDialog;
